const scrambledCls = "gfxs10j37bk";
const containerCls = "gfxc1ol1p8q";
const iconCls = "gfxi13s9rqv";

export { containerCls, iconCls, scrambledCls };
import "./Scrambled.linaria.module.css";
//# sourceMappingURL=Scrambled.js.map
